import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Logo } from './Logo';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  const openChatbot = () => {
    setIsMenuOpen(false);
    window.dispatchEvent(new CustomEvent('open-chatbot', { detail: { context: '' } }));
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-stone-900/95 backdrop-blur-md border-b border-amber-900/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Logo
            variant="horizontal"
            size="sm"
            onClick={() => scrollToSection('hero')}
          />

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-6">
            <button onClick={() => scrollToSection('hero')} className="text-stone-300 hover:text-amber-500 transition-colors font-medium">
              Início
            </button>
            <button onClick={() => scrollToSection('about')} className="text-stone-300 hover:text-amber-500 transition-colors font-medium">
              Quem Somos
            </button>
            <button onClick={() => scrollToSection('products')} className="text-stone-300 hover:text-amber-500 transition-colors font-medium">
              Produtos
            </button>
            <button onClick={() => scrollToSection('gallery')} className="text-stone-300 hover:text-amber-500 transition-colors font-medium">
              Galeria
            </button>
            <button onClick={() => scrollToSection('costelao-guide')} className="text-stone-300 hover:text-amber-500 transition-colors font-medium">
              Costelão
            </button>
            <button onClick={() => scrollToSection('customers')} className="text-stone-300 hover:text-amber-500 transition-colors font-medium">
              Clientes
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-stone-300 hover:text-amber-500 transition-colors font-medium">
              Contato
            </button>
            <button
              data-testid="header-cta-btn"
              onClick={openChatbot}
              className="bg-green-600 hover:bg-green-700 text-white px-5 py-2.5 rounded-lg font-semibold transition-all hover:scale-105 flex items-center gap-2"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              Fazer um Orçamento
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-white p-2"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-amber-900/30">
            <nav className="flex flex-col gap-4">
              <button onClick={() => scrollToSection('hero')} className="text-stone-300 hover:text-amber-500 transition-colors font-medium text-left py-2">
                Início
              </button>
              <button onClick={() => scrollToSection('about')} className="text-stone-300 hover:text-amber-500 transition-colors font-medium text-left py-2">
                Quem Somos
              </button>
              <button onClick={() => scrollToSection('products')} className="text-stone-300 hover:text-amber-500 transition-colors font-medium text-left py-2">
                Produtos
              </button>
              <button onClick={() => scrollToSection('gallery')} className="text-stone-300 hover:text-amber-500 transition-colors font-medium text-left py-2">
                Galeria
              </button>
              <button onClick={() => scrollToSection('costelao-guide')} className="text-stone-300 hover:text-amber-500 transition-colors font-medium text-left py-2">
                Costelão
              </button>
              <button onClick={() => scrollToSection('customers')} className="text-stone-300 hover:text-amber-500 transition-colors font-medium text-left py-2">
                Clientes
              </button>
              <button onClick={() => scrollToSection('contact')} className="text-stone-300 hover:text-amber-500 transition-colors font-medium text-left py-2">
                Contato
              </button>
              <button
                data-testid="header-mobile-cta-btn"
                onClick={openChatbot}
                className="bg-green-600 hover:bg-green-700 text-white px-5 py-3 rounded-lg font-semibold transition-all flex items-center justify-center gap-2 mt-2"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                Fazer um Orçamento
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
